import React from 'react';

const ServicesBanner = () => {
  return (
    <div className="services-banner">
      <div className="container">
        <div className="services-banner-wrapper">
          <h1>Algorithmic Trading</h1>
          <p>
            Welcome to our Algorithmic Trading service, where cutting-edge
            technology meets the financial markets.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServicesBanner;
